import { render, staticRenderFns } from "./rich-editor-image-uploader.vue?vue&type=template&id=46493959&scoped=true&"
import script from "./rich-editor-image-uploader.vue?vue&type=script&lang=js&"
export * from "./rich-editor-image-uploader.vue?vue&type=script&lang=js&"
import style0 from "./rich-editor-image-uploader.vue?vue&type=style&index=0&id=46493959&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46493959",
  null
  
)

export default component.exports